import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DisclaimerGate from "@/pages/DisclaimerGate";
import Landing from "@/pages/Landing";
import AdminLeads from "@/pages/AdminLeads";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DisclaimerGate />} />
          <Route path="/deck" element={<Landing />} />
          <Route path="/admin" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
